import SnapshotManage from './index';

export default {
    path: '/home/wallet/snapshot',
    component: SnapshotManage
}